module.exports = __webpack_public_path__ + "static/media/iconinfo.598db518.svg";